import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "col-12"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-success",
  role: "status"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "col-12"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", { class: "text-uppercase fw-bold mb-3" }, "Beneficio agotado", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "col-12"
}
const _hoisted_9 = {
  key: 3,
  class: "col-12"
}
const _hoisted_10 = { class: "text-uppercase fw-bold mb-3" }
const _hoisted_11 = { class: "text-uppercase fw-bold mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h5", { class: "text-uppercase fw-bold mb-3" }, " UTILIZÁ ESTE CODIGO DE PROMOCIÓN EN TU PRÓXIMA COMPRA: ", -1)
const _hoisted_13 = { class: "text-uppercase fw-bold mb-4" }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h5", null, "IR A LA TIENDA", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("small", { class: "mb-0 mt-4" }, " * Beneficio aplicable por única vez en tu primera compra aplicando el código de promoción que te brindaremos a continuación ", -1)

import { cuponesService } from '@/services/cupones.service'
import { userService } from '@/services/user.service'
import { onMounted, ref } from 'vue'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheCupones',
  props: {
    id: null,
    nombre: null
  },
  setup(__props: any) {

const props = __props as {
  id: string
  nombre: string
};

const { state, getters } = useStore<VuexStore>(key)



const loading = ref(false)

const cuponesDisponibles = ref(false)
const cupon = ref()
const url = ref()

const miCupon = async () => {
  const { codigo, store_url } = await userService.misCuponPorActividad(props.id)
  cupon.value = codigo
  url.value = store_url
}

const hayCuponesDisponibles = async () => {
  cuponesDisponibles.value = await cuponesService.hayCuponesDisponibles(
    props.id
  )
}
const obtenerCupon = async () => {
  loading.value = true
  const { codigo, store_url } = await cuponesService.obtenerCupon(props.id)
  cupon.value = codigo
  url.value = store_url

  loading.value = false
}

onMounted(async () => {
  loading.value = true
  if (getters.isLogin) {
    await miCupon()
    if (!cupon.value) {
      await hayCuponesDisponibles()
    }
  }
  loading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (!cupon.value && !cuponesDisponibles.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : (!cupon.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("button", {
                class: "btn btn-sm bg-light text-dark",
                type: "submit",
                onClick: obtenerCupon
              }, " Quiero mi beneficio ")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (url.value && url.value === '--')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("h6", _hoisted_10, " Para obtener este beneficio de " + _toDisplayString(props.nombre) + " serás contactado por un concesionario oficial en un lapso de 10 días. ", 1),
                    _createElementVNode("h6", _hoisted_11, " ¡Seguí navegando la web " + _toDisplayString(_unref(state).evento?.nombre) + " para enterarte de todos los beneficios que te dá ser miembro de la comunidad! ", 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_12,
                    _createElementVNode("h5", _hoisted_13, _toDisplayString(cupon.value), 1),
                    (url.value)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: url.value,
                          class: "text-white",
                          target: "_blank"
                        }, _hoisted_16, 8, _hoisted_14))
                      : _createCommentVNode("", true),
                    _hoisted_17,
                    _hoisted_18
                  ], 64))
            ]))
  ]))
}
}

})